export default __webpack_public_path__ + "static/media/github.da64659a.svg";